import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";

export class GoodsFormulaDetail extends EntityBase {
  public GoodsFormulaHeaderId: number;
  public GoodsId: number;
  public StandardAmount: number;
  public LossPercent: number;
  public LossAmount: number;
  public PriceRatio: number;
  public Comment: string;
  public LatinComment: string;
  public GoodsCode: string;
  public GoodsTitle: string;
  public GoodsLatinTitle: string;
  public HasGoodsSimilar: boolean;
  public GoodsSimilars: GoodsSimilar[];
  public GoodsKindCode?: number;
  public GoodsKindTitle: string;
  public GoodsKindLatinTitle: string;
  public GoodsUnitPrice: number;
  public GoodsPrice: number;
  public HeaderGoodsId: number;
  public TempRowNumber?: number;
  public RowNumber?: number;
}

export class GoodsFormulaHeader extends EntityBase {
  public GoodsId: number;
  public Amount: number;
  public Title: string;
  public LatinTitle: string;
  public Active: boolean;
  public IsResuarantWareHouse: boolean;
  public EffectDate: Date;
  public ShamsiEffectDate: string;
  public Comment: string;
  public LatinComment: string;
  public BranchId?: number;
  public GoodsCode: string;
  public GoodsTitle: string;
  public GoodsLatinTitle: string;
  public GoodsFormulaDetails: GoodsFormulaDetail[];
  public GoodsUnitRatio: number;
  public GoodsUnitTitle: string;
  public BranchCode?: number;
  public BranchTitle: string;
  public BranchLatinTitle: string;
  public TempRowNumber?: number;
  public CostPrice?: number;
}

export class GoodsSimilar extends EntityBase {
  public GoodsId: number;
  public GoodsFormulaDetailId: number;
  public StandardAmount?: number;
  public LossPercent?: number;
  public LossAmount?: number;
  public PriceRatio?: number;
  public Priority: number;
  public Comment: string;
  public LatinComment: string;
  public GoodsCode: string;
  public GoodsTitle: string;
  public GoodsLatinTitle: string;
  public GoodsUnitId?: number;
  public UnitTitle: string;
  public TempRowNumber?: number;
}
